//! IMPORTS
import { openDialog, dialogModel } from "components/common/dialog";

//! PROPS
const props = {
    pageMarker: ".marker-carousel-management",
    deleteCarouselItemButton: "#delete-carousel-item",
};

//! PUBLIC FUNCTIONS
export function initAdminCarouselManagement() {
    if (!$(props.pageMarker).length) return;

    //console.log("Carousel Management");
    handleDeleteCarouselItem();
}

//! PRIVATE FUNCTIONS
function handleDeleteCarouselItem() {
    $(props.deleteCarouselItemButton).click(function (e) {
        e.preventDefault();
        const actionDeleteUrl = $(this).data("action-delete");

        openDialog({
            ...dialogModel,
            title: "Delete Carousel Item",
            content: "Are you sure you want to delete this carousel item?",
            confirmButtonText: "Delete",
            onConfirm: function () {
                window.location.href = actionDeleteUrl;
            },
            theme: "delete",
        });
    });
}
